import { useTranslation } from 'react-i18next';
import { Button, Center, Heading, Text, VStack } from '@/ui';

export const SuspensionScreen = () => {
  const { t } = useTranslation('common');

  return (
    <Center flex="1" minH="100vh">
      <VStack
        borderRadius="12"
        px="12"
        py="8"
        spacing={4}
        transform="translateY(-100%)"
        w="500px"
      >
        <Heading fontSize="24px" textAlign="center">
          {t('suspension.title')}
        </Heading>
        <Text pb="4" textAlign="center">
          {t('suspension.message')}
        </Text>
        <Button
          as="a"
          href="mailto:support@agendahero.com"
          target="_blank"
          variant="secondary"
        >
          {t('suspension.contact_support')}
        </Button>
      </VStack>
    </Center>
  );
};
